<app-top-navigation-bar class="dark-theme"></app-top-navigation-bar>
<ng-http-loader [filteredUrlPatterns]="['\/backend-rest\/']" [filteredMethods]="['GET']" [debounceDelay]="1000"></ng-http-loader>
<section class="content" [class.logged-in]="isAuthenticated | async">
  <section class="container-fluid cupcake-content overflow-auto">
    <router-outlet></router-outlet>
  </section>
  <section class="angularjs">
    <app-ajs-frame frameSrc="/angularjs/"></app-ajs-frame>
  </section>
  <ngx-spinner size="medium" type="line-scale" [fullScreen]="false"></ngx-spinner>
</section>
